<template>
  <div class="container">
    <QuotationForm @change-title="changeTitle"/>
</div>
</template>

<script>
import QuotationForm from '@/views/quotations/components/QuotationForm.vue'
  export default {
    components: { QuotationForm },
    methods: {
      changeTitle(title) {
        if (title) {
          this.$emit('change-title', title);
        }
      }
    },
  }
</script>
<style src="../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"></style>
